<template>
  <div>
    <div id="wrapper">
      <!-- Sidebar -->
      <sidebar />
      <div id="content-wrapper" class="d-flex flex-column">
        <div id="content" style="position: relative;">
          <!--- Navbar ---->
          <navbar />
          <!-- Content -->
          <div class="main">
            <slot/>
          </div>
        </div>
        <!-- Footer -->
        <footer class="sticky-footer bg-white">
          <div class="container my-auto">
            <div class="copyright text-center my-auto">
              <span>Copyright &copy; Dashtaco 2022</span>
            </div>
          </div>
        </footer>
      </div>
    </div>
    <!-- Scroll to Top Button-->
    <a class="scroll-to-top rounded" href="#page-top">
      <i class="fas fa-angle-up"></i>
    </a>
  </div>
</template>

<script>
import Navbar from "../layout/Navbar.vue";
import {mapActions} from "vuex";
import Sidebar from "../layout/Sidebar.vue";

import init from "@/core/mixins/init";

export default {
  name: "Dashboard",
  mixins: [init],
  components:{
    Navbar,
    Sidebar
  },
  computed:{
    isLoggedIn : function(){ return this.$store.getters.isAuthenticated}
  },
  created() {
    this.loadCategoriesSelect()
    this.loadSousCategories()
    this.loadOutlets()
  },
  methods: {
    ...mapActions('categories', ['loadCategoriesSelect', 'loadSousCategories']),
    ...mapActions('outlets', ['loadOutlets']),
    showSidebar(event){
      return event
    }
  },
}
</script>

<style scoped>
.select {
  border-radius: 0 !important;
}
.container{
  text-align: start;
}

a,
a:hover,
a:focus {
  color: inherit;
  text-decoration: none;
  transition: all 0.3s;
}
.line {
  width: 100%;
  height: 1px;
  border-bottom: 1px dashed #ddd;
  margin: 40px 0;
}



/* ---------------------------------------------------
  CONTENT STYLE
----------------------------------------------------- */

#content {
  width: 100%;
  min-height: 100vh;
  transition: all 0.3s;
  position: absolute;
  top: 0;
  right: 0;
}
.overlay.active {
  display: block;
  opacity: 1;
}
.overlay {
  display: none;
  position: fixed;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  z-index: 998;
  opacity: 0;
  transition: all 0.5s ease-in-out;
}

@media (min-width: 768px) {
  #sidebar {
    margin-left: 0;
  }

  #content {
    min-width: 0;
    width: 100%;
  }
  .show
  {
    margin-left: 0!important;
  }
  .hide
  {
    margin-left: 250px!important;
  }
}
@media (max-width: 767px) {
  .show
  {
    margin-left: 0!important;
  }
  .hide
  {
    margin-left: 250px!important;
  }
}
</style>
